import { SvgIconType } from './svg.interface';

const TrashBin: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  color = '#8792A2',
  onClick
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      d="M0.751465 2.25V3H11.2541V2.25C11.2541 1.83579 10.9183 1.5 10.5041 1.5H7.50002C7.50002 0.671573 6.82845 0 6.00002 0C5.1716 0 4.50002 0.671573 4.50002 1.5H1.50146C1.08725 1.5 0.751465 1.83579 0.751465 2.25Z"
      fill={color}
    />
    <path
      d="M9.78565 11.2875L10.125 4.5H1.87502L2.2144 11.2875C2.23435 11.6866 2.56381 12 2.96346 12H9.03659C9.43624 12 9.76569 11.6866 9.78565 11.2875Z"
      fill={color}
    />
  </svg>
);

export default TrashBin;
